import { Autocomplete, TextField } from "@mui/material";


const Select = ({ label, options, getValue, value }) => {

  return (
    <Autocomplete
      disablePortal
      id="combo-box-demo"
      options={options}
      value={value}
      onChange={(event, newValue) => getValue(newValue)}
      className="custom-select"
      isOptionEqualToValue={(option, value) => option === value}
      sx={{
        width: '100%',
        '& .MuiInputBase-root': {
          overflow: 'hidden',
        },
        '& .MuiAutocomplete-input': {
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
        }
      }}
      renderOption={(props, option) => (
        <li {...props} style={{ whiteSpace: 'normal', wordBreak: 'break-word', fontSize: '14px' }}>
          {option}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          className="custom-textfield"
          sx={{
            '& .MuiInputLabel-root': {
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              maxWidth: '90%'
            }
          }}
        />
      )}
    />
  );
};

export default Select;
